import React from 'react';
import { useLayoutEffect, useEffect, useState, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';

// window size cal 
import useWindowDimensions from './getWindowsDimensions.js';

const LogoScrollGSAP = ({ imgsrc }) => {
    const logoScrollRef = useRef(); 
    const { height, width } = useWindowDimensions();
    const widthColPx = 800;

    const logo_img_container = {

        position: "fixed",
        top: "1vh",
        zIndex: "8",
        display: "block",
        marginLeft: "3%",
    }
    const comp_logo = {
        width: "100%",
        maxWidth: "300px",
        minWidth: "100px",
        transition: "0.1s",
        transformOrigin: "top left",
    }
    const comp_logo_mobile = {
        width: "100%",
        maxWidth: "150px",
        minWidth: "50px",
        
        transformOrigin: "top left",
    }

    const el = useRef();
    const q = gsap.utils.selector(el);
  
    useLayoutEffect(() => {
        const ctx = gsap.context((self) => {
            gsap.timeline({
                scrollTrigger: {
                    trigger: el.current,
                    start: "top top",
                    end: "bottom top",
                     
                    //invalidateOnRefresh : true,  // color change error on refresh 
                    //    refreshPriority: 1,
                    //markers: true,   
                    scrub: 1,
                    // pin: true, //  causing pinning problem (moves after end ) 
                }
            }).fromTo(q("#logoimg"), {
                scale: 1.2,
            }, {
                scale: 1.0,
            });
        }, el); // <- Scope!
        return () => ctx.revert(); // <- Cleanup!
      }, []);

   
    return (
        <div style={logo_img_container} ref={el} id="logogsap">
            <img ref = {logoScrollRef} style={width < widthColPx ? comp_logo_mobile : comp_logo} src={imgsrc} id="logoimg" />
        </div>

    )
}

export default LogoScrollGSAP